import React, { useMemo, useState, useEffect } from 'react'
import useI18n from 'hooks/useI18n'
import styled from 'styled-components'
import { Text, Flex, Link, LinkExternal, CopyIcon } from '@pancakeswap-libs/uikit'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import getLiquidityUrlPathParts from 'utils/getLiquidityUrlPathParts'
import { sortLpTokens } from 'utils/lpUtils'
import { Address } from 'config/constants/types'

export interface ExpandableSectionProps {
  ranch: any
  lpLabel?: string
}

const DexUrls = {
  0: "https://dexfull.benswap.cash"
};

const getDexUrl = ()=>{
  return DexUrls[0];
}

const Wrapper = styled.div`
  margin-top: 24px;
`

const StyledLinkExternal = styled(LinkExternal)`
  text-decoration: none;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;

  svg {
    padding-left: 4px;
    height: 18px;
    width: auto;
    fill: ${({ theme }) => theme.colors.primary};
  }
`

const StyledText1 = styled(Text)`
  display: inline-block;
`

const StyledText2 = styled(StyledText1)`
  margin-right: 5px;
`

const StyledLinkExternal2 = styled(LinkExternal)`
  text-decoration: none;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.text};
  display: inline-block;
  position: relative;

  svg {
    position: relative;
    top: 3px;
    display: inline-block;
    vertical-align: top;
    padding-left: 4px;
    height: 18px;
    width: auto;
    fill: ${({ theme }) => theme.colors.primary};
  }
`

const Row2 = styled.div`
  text-align: right;
`

const StyledCopyToClipboard = styled(CopyToClipboard)`
  color: #f98c08;
  line-height: 24px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

const CopySuccessText = styled.div`
    color: #2aa339fa;
    margin-left: 20px;
    line-height: 24px;
`

const getDisplayBalance = (balance) => {
  const displayBalanceOption = balance > 1 ? {} : {maximumFractionDigits: 8};
  const displayBalance = navigator ? balance.toLocaleString(navigator.language, displayBalanceOption) : balance.toLocaleString();
  return displayBalance;
}

const DetailsSection: React.FC<ExpandableSectionProps> = ({
  ranch
}) => {
  const { address, token, lpToken, emissionPerBlock, isEnded, balance, lpBalance, userInfo, owner, feeAddress, depositFeeRate } = ranch;
  const TranslateString = useI18n()
  const sortedTokensInLp = sortLpTokens(lpToken.token0, lpToken.token1);
  const lpLabel = `${sortedTokensInLp[0].symbol}-${sortedTokensInLp[1].symbol} LP`;
  const quoteTokenAdresses = {10000: sortedTokensInLp[1].address};
  const quoteTokenSymbol = sortedTokensInLp[1].symbol;
  const tokenAddresses = {10000: sortedTokensInLp[0].address};
  const liquidityUrlPathParts = getLiquidityUrlPathParts({ quoteTokenAdresses, quoteTokenSymbol, tokenAddresses })

  const lpStakedValue = lpBalance.div(lpToken.totalSupply).times(lpToken.value || 0);
  const totalValueFormated = lpToken.value
    ? `$${getDisplayBalance(lpStakedValue.toNumber())}`
    : '-';

  const lpShare = lpBalance.div(lpToken.totalSupply);
  const userShare = (userInfo && lpBalance.isGreaterThan(0)) ? userInfo.stakedLp.div(lpBalance).toNumber() : 0;
  const userSharePercentageFormatted = `${(userShare*100).toLocaleString(undefined, { maximumFractionDigits: 4 })}%`;

  const [showCopySuccess1, setShowCopySuccess1] = useState(false);
  const [showCopySuccess2, setShowCopySuccess2] = useState(false);

  const copying1 = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!showCopySuccess1) document.dispatchEvent(new Event("beforeCopyAnything"));
    setShowCopySuccess1(true)
  }

  const copying2 = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!showCopySuccess2) document.dispatchEvent(new Event("beforeCopyAnything"));
    setShowCopySuccess2(true)
  }
  
  useEffect(() => {
    const handleClickOutside = () => {
      setShowCopySuccess1(false)
      setShowCopySuccess2(false)
    }

    document.addEventListener('click', handleClickOutside)
    document.addEventListener('beforeCopyAnything', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
      document.removeEventListener('beforeCopyAnything', handleClickOutside)
    }
  }, [])

  return (
    <Wrapper>
      <Flex justifyContent="space-between">
        <Text>{TranslateString(1333,'Staking')}:</Text>
        <StyledLinkExternal href={`${getDexUrl()}/#/add/${liquidityUrlPathParts}`}>
          {lpLabel}
        </StyledLinkExternal>
      </Flex>
      {
        !!isEnded && (
          <Flex justifyContent="space-between">
            <Text>{TranslateString(545,'Earning')}:</Text>
            <StyledLinkExternal href={`https://smartscout.cash/address/${token.address}`}>
              {token.symbol}
            </StyledLinkExternal>
          </Flex>
        )
      }
      {
        isEnded ? "": (
          <Flex justifyContent="space-between">
            <Text>{TranslateString(444,"Emission")}:</Text>
            <Text>{`${getDisplayBalance(emissionPerBlock.toNumber())} ${token.symbol}/block`}</Text>
          </Flex>
        )
      }
      {
        userShare>0 && (
          <Flex justifyContent="space-between">
            <Text>{TranslateString(92, 'Staked')}:</Text>
            <Text>{`${getDisplayBalance(userInfo.stakedLp.toNumber())} (${userSharePercentageFormatted})`}</Text>
          </Flex>
        )
      }
      {
        userShare>0 && lpToken.value && (
          <Row2>
            <StyledText1>${getDisplayBalance(lpStakedValue.times(userShare).toNumber())}</StyledText1>
          </Row2>
        )
      }
      {
        userShare>0 && (
          <Row2>
            <StyledText2>{getDisplayBalance(lpToken.reserve0.times(lpShare).times(userShare).toNumber())}</StyledText2>
            <StyledLinkExternal2 href={`https://smartscout.cash/address/${lpToken.token0.address}`}>
              {lpToken.token0.symbol}
            </StyledLinkExternal2>
          </Row2>
        )
      }
      {
        userShare>0 && (
          <Row2>
            <StyledText2>{getDisplayBalance(lpToken.reserve1.times(lpShare).times(userShare).toNumber())}</StyledText2>
            <StyledLinkExternal2 href={`https://smartscout.cash/address/${lpToken.token1.address}`}>
              {lpToken.token1.symbol}
            </StyledLinkExternal2>
          </Row2>
        )
      }
      <Flex justifyContent="space-between">
        <Text>{TranslateString(125, 'Total Liquidity')}:</Text>
        <Text>{totalValueFormated}</Text>
      </Flex>
      <Flex justifyContent="space-between">
        <Text>{TranslateString(117,'Owner')}:</Text>
        <StyledLinkExternal href={`https://smartscout.cash/address/${owner}`}>
          {owner && owner.substring(0, 6)}
        </StyledLinkExternal>
      </Flex>
      {
        depositFeeRate > 0 && !isEnded && (
          <Flex justifyContent="space-between">
            <Text>{TranslateString(544,'Fee Address')}:</Text>
            <StyledLinkExternal href={`https://smartscout.cash/address/${feeAddress}`}>
              {feeAddress && feeAddress.substring(0, 6)}
            </StyledLinkExternal>
          </Flex>
        )
      }
      <Flex justifyContent="flex-start" onClick={(e)=>{e.stopPropagation();}}>
        <StyledCopyToClipboard text={address} onCopy={copying1} title={TranslateString(1320, 'Copy Ranch Address')}>
          <span>
            {TranslateString(1320, 'Copy Ranch Address')}
            <CopyIcon style={{ verticalAlign: 'middle', marginLeft: 4, position: "relative", top: "-1px", cursor: 'pointer', display: 'inline-block', fill: '#f98c08' }} />
          </span>
        </StyledCopyToClipboard>
        {showCopySuccess1 && <CopySuccessText>{TranslateString(1315, 'Copied!')}</CopySuccessText>}
      </Flex>
      <Flex justifyContent="flex-start" onClick={(e)=>{e.stopPropagation();}}>
        <StyledCopyToClipboard text={`https://benswap.cash/ranches?ranch=${address}`} onCopy={copying2} title={TranslateString(1317, 'Copy Link')}>
          <span>
            {TranslateString(1317, 'Copy Link')}
            <CopyIcon style={{ verticalAlign: 'middle', marginLeft: 4, position: "relative", top: "-1px", cursor: 'pointer', display: 'inline-block', fill: '#f98c08' }} />
          </span>
        </StyledCopyToClipboard>
        {showCopySuccess2 && <CopySuccessText>{TranslateString(1315, 'Copied!')}</CopySuccessText>}
      </Flex>
      <Flex justifyContent="flex-start">
        <Link external href={`https://smartscout.cash/address/${address}`} bold={false}>
          {TranslateString(95, 'View on Smartscout')}
        </Link>
      </Flex>
    </Wrapper>
  )
}

export default DetailsSection
